<div *ngIf="selectedData[2]=='vacation'">
    <div fxLayoutAlign="center" fxLayout="row wrap">
        <mat-card class="day-cards green-card">
            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"> Annual Leave Entitlement
            </mat-card-subtitle>
            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                {{getDisplayValue.get('leaveEntitlement')}}
            </mat-card-content>
        </mat-card>
        <mat-card class="day-cards red-card">
            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"><br/> Remaining Days
            </mat-card-subtitle>
            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                {{getDisplayValue.get('remainingDays')}}
            </mat-card-content>
        </mat-card>
        <mat-card class="day-cards amber-card">
            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"><br/> Pending Days
            </mat-card-subtitle>
            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                {{getDisplayValue.get('pendingDays')}}
            </mat-card-content>
        </mat-card>
        <mat-card class="day-cards blue-card">
            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"><br/> Pending Requests
            </mat-card-subtitle>
            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                {{getDisplayValue.get('pendingRequests')}}
            </mat-card-content>
        </mat-card>
    </div>
</div>
<div *ngIf="selectedData[2]=='workAbroad'">
    <div fxLayoutAlign="center" fxLayout="row wrap">
        <mat-card class="day-cards green-card">
            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"> Work Abroad Entitlement
            </mat-card-subtitle>
            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                {{getDisplayValue.get('leaveEntitlement')}}
            </mat-card-content>
        </mat-card>
        <mat-card class="day-cards red-card">
            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"><br/> Remaining Days
            </mat-card-subtitle>
            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                {{getDisplayValue.get('remainingDays')}}
            </mat-card-content>
        </mat-card>
        <mat-card class="day-cards amber-card">
            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"><br/> Pending Days
            </mat-card-subtitle>
            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                {{getDisplayValue.get('pendingDays')}}
            </mat-card-content>
        </mat-card>
        <mat-card class="day-cards blue-card">
            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"> Remaining Annual Leave
            </mat-card-subtitle>
            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                {{getDisplayValue.get('pendingRequests')}}
            </mat-card-content>
        </mat-card>
    </div>
</div>
<br/>
<div fxLayoutAlign="center" *ngIf="selectedData[2]=='vacation'"><h2>{{this.selectedData[1].firstName |titlecase}} {{this.selectedData[1].lastName |titlecase}}</h2></div>
<div fxLayoutAlign="center" *ngIf="selectedData[2]=='vacation'"><h2>Vacation Requests</h2></div>
<div fxLayoutAlign="center" *ngIf="selectedData[2]=='workAbroad'"><h2>{{this.selectedData[1].firstName |titlecase}} {{this.selectedData[1].lastName |titlecase}}</h2></div>
<div fxLayoutAlign="center" *ngIf="selectedData[2]=='workAbroad'"><h2>Work Abroad Requests</h2></div>
<div fxLayout="row wrap" fxLayoutAlign="center">

    <mat-table [dataSource]="dataSource" matSort matTableFilter>
        <ng-container *ngFor="let field of fieldNames;let i=index" matColumnDef="{{field}}">
            <th id="header" mat-header-cell mat-sort-header="{{field}}" *matHeaderCellDef
                class="mat-column-standard">
                {{displayNames[i]}}
            </th>
            <td mat-cell *matCellDef="let tableData" class="mat-column-standard center-text">
                <div *ngIf="field=='halfDay'">
                    {{halfDayStatus(tableData[field])}}
                </div>
                <div *ngIf="field=='numberOfAnnualLeaveDays'">
                    {{tableData[field]}}
                </div>
                <div *ngIf="field=='numberOfWorkAbroadDays'">
                    {{tableData[field]}}
                </div>
                <div *ngIf="field =='dateCreated' || field=='startDate' || field=='endDate'">
                    {{tableData[field] | date: 'dd/MM/yyyy'}}
                </div>
                <div *ngIf="field !=='numberOfAnnualLeaveDays'&& field !=='halfDay' && field !=='dateCreated' && field !=='numberOfWorkAbroadDays' && field!=='absenceType' && field !== 'startDate' && field !== 'endDate' && field !== 'absenceReason'">
                    {{tableData[field] |titlecase}}
                </div>
                <div *ngIf="field=='absenceReason' && tableData['absenceReason'].length <= 25">
                    {{tableData[field]}}
                </div>
                <div *ngIf="field=='absenceReason' && tableData['absenceReason'].length > 25"
                     matTooltip="{{tableData[field]}}"
                     matTooltipPosition="left">
                    {{tableData[field].slice(0, 25) + '...'}}
                </div>
                <div *ngIf="field=='absenceType'">
                    {{ tableData[field] | titlecase | removeUnderscorePipe }}
                </div>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="fieldNames; sticky: true;"></tr>
        <tr mat-row *matRowDef="let row = row; let even = even; columns: fieldNames;"
            [ngClass]="{blueBackground : even}"></tr>
    </mat-table>
</div>

